import React, { useState, useEffect } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container'
import Button from '@material-ui/core/Button'
import StyledFirebaseAuth from 'react-firebaseui/StyledFirebaseAuth';
import firebase from 'firebase/app';
import 'firebase/auth';
import * as firebaseui from 'firebaseui'
import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
  },
  menuButton: {
    marginRight: theme.spacing(2),
  },
  title: {
    flexGrow: 1,
  },
  menuBar: {
    background: '#0a304e',
  }
}));

const firebaseConfig = {
  apiKey: "AIzaSyBrixgo2tu0q_TnK1u80t3ZL9N9Vbg6Ox0",
  authDomain: "online-cle-dev.firebaseapp.com",
  databaseURL: "https://online-cle-dev.firebaseio.com",
  projectId: "online-cle-dev",
  storageBucket: "online-cle-dev.appspot.com",
  messagingSenderId: "1068889445181",
  appId: "1:1068889445181:web:0c1006fd006b71fc0dab54"
};

firebase.initializeApp(firebaseConfig);

export default function MenuWithLogin(props) {
  const [open, setOpen] = React.useState(false);
  const [loggedIn, setLoggedIn] = useState(false)
  const [userToken, setUserToken] = useState(null)

  const classes = useStyles()

  useEffect(() => {
    const unregisterAuthObserver = firebase.auth().onAuthStateChanged(user => {
      console.log("onAuthStateChanged");
      setLoggedIn(!!user);
      if (user) {
        user.getIdToken(true).then((idToken) => {
          setUserToken(idToken)
        });
      } else {
        setUserToken(null)
      }
    });

    firebase.auth().onIdTokenChanged(function(user) {
      console.log("onIdTokenChanged");
      if(user) {
        user.getIdToken(true).then((idToken) => {
          setUserToken(idToken)
        });
      } else{
        setUserToken(null)
      }
    });

    return () => unregisterAuthObserver(); // Make sure we un-register Firebase observers when the component unmounts.
  }, []);  

  const handleLoginBoxOpen = () => {
    setOpen(true);
  };

  const handleSignOut = () => {
    firebase.auth().signOut().then(function() {
      setLoggedIn(false)
      setUserToken(null)
    }).catch(function(error) {
      console.log(error)
    });
  }

  const getAuthToken = () =>{  
  }

  const handleClose = () => {
    setOpen(false);
  };

  const uiConfig = {
    callbacks: {
      // Avoid redirects after sign-in.
      signInSuccessWithAuthResult: (authResult, redirectUrl) => {
        var user = authResult.user;
        var credential = authResult.credential;
        var isNewUser = authResult.additionalUserInfo.isNewUser;
        var providerId = authResult.additionalUserInfo.providerId;
        var operationType = authResult.operationType;
        // Do something with the returned AuthResult.
        // Return type determines whether we continue the redirect
        // automatically or whether we leave that to developer to handle.

        setOpen(false);

        return false;
      },
      signInFailure: function(error) {
        // Some unrecoverable error occurred during sign-in.
        // Return a promise when error handling is completed and FirebaseUI
        // will reset, clearing any UI. This commonly occurs for error code
        // 'firebaseui/anonymous-upgrade-merge-conflict' when merge conflict
        // occurs. Check below for more details on this.

        console.log("signInFailure", error);
        // return handleUIError(error);
      },      
      uiShown : () => {
        console.log("Authentication UI shown");
      }
    },
    // Will use popup for IDP Providers sign-in flow instead of the default, redirect.
    signInFlow: 'popup',
    //firebaseui.auth.CredentialHelper.NONE is the correct way to set this but I don't want to import the whole library for the 'none' string
    credentialHelper: firebaseui.auth.CredentialHelper.NONE,
    signInOptions: [
      {
        // Leave the lines as is for the providers you want to offer your users.
        provider: firebase.auth.EmailAuthProvider.PROVIDER_ID,
        requireDisplayName: false
      }
    ],
    immediateFederatedRedirect: false,
  }

  return (
    <React.Fragment>
      <div className={classes.root}>
        <AppBar position="static" className={classes.menuBar}>
          <Toolbar>
            <Typography variant="h6" className={classes.title}>
              {props.title}
            </Typography>
            {loggedIn? 
            <Button color="inherit" onClick={handleSignOut}>Logout</Button>
            :
            <Button color="inherit" onClick={handleLoginBoxOpen}>Login</Button>
            }
          </Toolbar>
        </AppBar>
      </div>

      <Container maxWidth={props.size}>
        {props.children &&
          props.children.map((child, index) =>{
            return React.cloneElement(child, {key:index, authToken: userToken})
          })
        }
      </Container>

      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">Subscribe</DialogTitle>
        <DialogContent>
          <DialogContentText>
            By signing in with your email address your progress in videos as well as completed videos will be saved so you can finish a video later.
          </DialogContentText>
          <StyledFirebaseAuth uiConfig={uiConfig} firebaseAuth={firebase.auth()}/>
        </DialogContent>
      </Dialog>

    </React.Fragment>
  );
}